export function getGlossary (lang){
    switch (lang){
        case "fa":return fa;
        case "en":return en;
        default: return fa;
    }
}

const fa = {
    dir: "rtl",
    siteName: "کیان پرداز",
    siteDescription: "پرتال مشتریان کیان پرداز هوشمند",
    invoices: {title:"فاکتورها", description:"فاکتورهای خرید شما"} ,
    support: {title:"تیکت پشتیبانی", description: "از راه‌های زیر با پشتیبانی در ارتباط باشید."},
    userManagement: "مدیریت کاربری",
    signOut: "خروج",
    userID: "شناسه کاربر",
    supportAnswer: "پاسخ پشتیبان",
    previous: "قبلی",
    next: "بعدی",
}

const en = {
    dir: "ltr",
    siteName: "Kian Pardaz",
    siteDescription: "Registration of electronic invoices for transactions",
    invoices: {title:"Invoices", description:"Some Description for invoice"} ,
    support: {title:"Support", description: "Some Description for support"},
    userManagement:  "User Management",
    signOut: "Sign Out",
    userID: "User Identity",
    supportAnswer: "Support Answer",
    previous: "Previous",
    next: "Next",
}